/**
 * Error handling facade for the dashboard.
 *
 * The error *model* (codes, severities, retryability, wire envelope, user-copy
 * resolution) is owned by `@authe/fe-commons/errors` + `@authe/ui-core/notify`.
 * This module re-exports that surface so feature code has ONE import, and adds
 * the handful of dashboard-only error situations that aren't backend codes.
 */
export { toErrorResponse, AutheError, getCodeSpec } from "@authe/fe-commons/errors";
export type { ErrorResponse, ErrorBody } from "@authe/fe-commons/errors";
export { notifyError, notifySuccess, notifyInfo, notifyWarning } from "@authe/ui-core/notify";

/** Dashboard-only, client-side error situations (not part of the API catalog). */
export const DASHBOARD_ERRORS = {
  SESSION_LOOP: {
    title: "Sign-in could not complete",
    description:
      "We detected a redirect loop with the login site. Clear your cookies for this domain and try again.",
  },
  NO_TENANT: {
    title: "No active tenant",
    description: "Your session has no tenant context. Pick a tenant or contact your administrator.",
  },
  FEATURE_DISABLED: {
    title: "Not available on your plan",
    description: "This feature is not enabled for your organization.",
  },
} as const;

export type DashboardErrorKey = keyof typeof DASHBOARD_ERRORS;
